<template>
	<div class="wrap">
		<Title title="发起活动"></Title>
		<div class="steps">
			<div class="steps-list steps-current">
				<i>1</i>
				<span>活动信息</span>
			</div>
			<div class="steps-line"></div>
			<div class="steps-list">
				<i>2</i>
				<span>包裹发放</span>
			</div>
		</div>
		<!--第一步-->
		<div class="step1" v-if="stepIndex==0">
			<el-form :model="formInfo" :rules="rules" ref="ruleForm" label-width="140px" class="add-form">
				<el-form-item label="活动名称" prop="vacationName">
					<el-input clearable placeholder="请输入活动名称" v-model="formInfo.vacationName"></el-input>
				</el-form-item>
				<el-form-item label="活动类型" prop="activityType">
					<el-select :disabled="formInfo.id!=''&&auditStatus==2" v-model="formInfo.activityType" placeholder="请选择活动类型">
						<el-option label="包裹发放" value="0"></el-option>
						<el-option label="最美推荐" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="formInfo.activityType=='0'" label="领取方式" prop="deliveryType">
					<el-radio-group v-model="formInfo.deliveryType" :disabled="formInfo.id!=''&&auditStatus==2">
						<el-radio label="1">邮寄配送</el-radio>
						<el-radio label="0">现场领取</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item label="活动logo" prop="logoFileUrl">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="1"
						:file-list="logoList" :before-upload="beforeUpload" :on-success="handleSuccessLogo"
						:on-preview="handlePreviewLogo" :on-remove="handleRemoveLogo">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item> -->
				<el-form-item label="活动海报" prop="bannerFileUrl">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="1"
						:file-list="bannerList" :before-upload="beforeUpload" :on-success="handleSuccessBanner"
						:on-preview="handlePreviewLogo" :on-exceed="handleExceedbanner" :on-remove="handleRemoveLogo">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<el-form-item label="宣传视频" prop="poster">
					<el-upload :action=uploadUrl :limit="1"  :before-upload="beforeUploadVideo" accept=".mp4,.avi" :on-success="handleSuccessVideo"
						:on-preview="handlePreviewLogo" :on-remove="handleRemoveVideo">
						<el-button size="small" type="primary">点击上传视频</el-button>
					</el-upload>
					<video class="upload-video" v-if="this.formInfo.videoFileUrl" autoplay muted
						:src="this.formInfo.videoFileUrl" style="width:100%"></video>
				</el-form-item>
				<el-form-item label="活动描述" prop="content">
					<div class="editor-wrap">
						<quill-editor class="editor" v-model="formInfo.content" ref="myQuillEditor" :options="editorOption"/>
					</div>
					<!-- <el-input :rows="6" type="textarea" clearable placeholder="请输入活动介绍"
						v-model="formInfo.content"></el-input> -->
				</el-form-item>
				<el-form-item class="sponsor" label="赞助方logo" prop="bannerFileUrl">
					<el-upload :action=uploadUrl list-type="picture-card" accept=".jpg,.jpeg,.png,.gif" :limit="3"
						:file-list="sponsorListBack" :before-upload="beforeUpload" :on-success="handleSuccessSponsor"
						:on-preview="handlePreviewLogo" :on-remove="handleRemoveSponsor">
						<i class="el-icon-plus"></i>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible">
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form-item>
				<el-form-item label="招募开始时间" prop="recruitStartTime">
					<el-date-picker align="center" :disabled="formInfo.id!=''&&auditStatus==2" v-model="formInfo.recruitStartTime"
						type="date" value-format="yyyy-MM-dd" placeholder="请选择开始时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="招募结束时间" prop="recruitEndTime">
					<el-date-picker align="center" :disabled="formInfo.id!=''&&auditStatus==2&&publishStatus!=1" v-model="formInfo.recruitEndTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择结束时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="招募人数" prop="recruitNums">
					<el-input :disabled="formInfo.id!=''&&auditStatus==2" clearable placeholder="招募人数" v-model="formInfo.recruitNums">
						<template>.com</template>
					</el-input>
				</el-form-item>
				<el-form-item label="抢席位名额" prop="cardNum">
					<el-input :disabled="formInfo.id!=''&&auditStatus==2" clearable placeholder="设定抢席位名额(此名额是通过分享传播方可优先入选)"
						v-model="formInfo.cardNum"></el-input>
				</el-form-item>
				<el-form-item label="招募范围" prop="recruitType">
					<el-select :disabled="formInfo.id!=''&&auditStatus==2" v-model="formInfo.recruitType" placeholder="请选择活动类型"
						@change="selectRecruitType">
						<el-option label="全国范围高校" value="0"></el-option>
						<el-option label="限定地区高校" value="1"></el-option>
					</el-select>
					<div v-if="formInfo.recruitType==1" class="select-area">
						<el-select :disabled="formInfo.id!=''&&provinceName!=''&&auditStatus==2" v-model="provinceName" placeholder="请选择省">
							<el-option v-for="item in provinceList" :label="item.keyName"
								:value="item.keyName"></el-option>
						</el-select>
						<el-select :disabled="formInfo.id!=''&&cityName!=''&&auditStatus==2" v-model="cityName" placeholder="请选择市"
							@visible-change="cityChange">
							<el-option v-for="item in cityList" :label="item.keyName" :value="item.keyName"></el-option>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item label="联系人" prop="contactPerson">
					<el-input clearable placeholder="联系人" v-model="formInfo.contactPerson"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="contactPhone">
					<el-input clearable placeholder="联系电话" v-model="formInfo.contactPhone"></el-input>
				</el-form-item>
				<el-form-item label="社会实践服务时长" prop="practiceHour">
					<el-input :disabled="formInfo.id!=''&&auditStatus==2" clearable placeholder="在此为志愿者设定本次活动的志愿服务时长(单位：小时)"
						v-model="formInfo.practiceHour"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="formInfo.activityType == 0"  class="confirm-btn" size="mini" type="primary" @click="toConfirm">下一步</el-button>
					<el-button v-if="formInfo.activityType == 1"  class="confirm-btn" size="mini" type="primary" @click="toConfirm">提交</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--第二步-->
		<div class="step2" v-else>
			<el-form :model="formInfo2" :rules="rulesForm2" ref="ruleForm2" label-width="140px" class="add-form">
				<el-form-item label="物资来源" prop="materialSources">
					<el-radio-group :disabled="publishStatus==1" v-model="formInfo2.materialSources">
						<el-radio label="0">平台采购</el-radio>
						<el-radio label="1">自备包裹</el-radio>
					</el-radio-group>
				</el-form-item>
				<div v-if="formInfo2.materialSources==0">
					<el-button style="margin: 0 0 15px 140px" size="mini" type="primary"
						@click="selectGoods">选择商品</el-button>
					<el-form-item label="包裹名称">
						<el-input clearable disabled v-model="formInfo2.packName"></el-input>
					</el-form-item>
					<el-form-item label="商品类型">
						<el-input clearable disabled v-model="formInfo2.packType"></el-input>
					</el-form-item>
					<el-form-item label="签收人数">
						<el-input clearable disabled v-model="formInfo2.signerNum"></el-input>
					</el-form-item>
					<el-form-item label="价格(元)">
						<el-input clearable disabled v-model="formInfo2.packPrice"></el-input>
					</el-form-item>
					<el-form-item label="起订数量">
						<el-input clearable disabled v-model="formInfo2.miniNum"></el-input>
					</el-form-item>
					<el-form-item label="备货周期(天)">
						<el-input clearable disabled v-model="formInfo2.leadTime"></el-input>
					</el-form-item>
					<el-form-item label="订购数量" prop="purchaseNum">
						<el-input clearable placeholder="订购数量" v-model="formInfo2.purchaseNum"></el-input>
					</el-form-item>
				</div>
				<div v-else>
					<el-form-item label="签收人数" prop="signNum">
						<el-input :disabled="publishStatus==1" clearable placeholder="请填写每个包裹需要的签收人数" v-model="formInfo2.signNum"></el-input>
					</el-form-item>
					<el-form-item label="包裹价值(元)" prop="packPrice">
						<el-input :disabled="publishStatus==1" clearable placeholder="请填写每个包裹的价值(元)" v-model="formInfo2.packPrice"></el-input>
					</el-form-item>
					<el-form-item label="给受助者物品" prop="goodsDetails">
						<div class="editor-wrap">
							<quill-editor class="editor" v-model="formInfo2.goodsDetails" ref="myQuillEditor" :options="editorOption1"/>
						</div>
						<!-- <el-input :rows="6" type="textarea" clearable placeholder="列明每个受助者需要签收的物品名称及数量"
							v-model="formInfo2.goodsDetails"></el-input> -->
					</el-form-item>
					<el-form-item label="给志愿者物品" prop="volunteerItemDetails" style="margin-top: 10px;">
						<div class="editor-wrap">
							<quill-editor class="editor" v-model="formInfo2.volunteerItemDetails" ref="myQuillEditor" :options="editorOption1"/>
						</div>
						<!-- <el-input :rows="6" type="textarea" clearable placeholder="列明每个志愿者需要签收的物品名称及数量"
							v-model="formInfo2.volunteerItemDetails"></el-input> -->
					</el-form-item>
				</div>
				<div class="steps-btn">
					<el-button size="mini" type="primary" @click="toPrev">上 一 步</el-button>
					<el-button size="mini" type="primary" @click="toSubmit">提交</el-button>
				</div>

			</el-form>
		</div>
		<!--选择商品弹窗-->
		<el-dialog title="选择商品" :visible.sync="dialogSelVisible" width="70%">
			<el-form :inline="true" class="dialog-form">
				<el-form-item label="背包名称">
					<el-input v-model="packName" placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">搜索</el-button>
					<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
			<el-table border size="mini" :data="goodsList" style="width: 100%">
				<el-table-column prop="packName" label="背包名称">
					<template slot-scope="scope">
						<span class="select-txt" @click="toPackDetail(scope.row)">{{scope.row.packName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="packType" label="类型">
					<template slot-scope="scope">
						<span v-if="scope.row.packType==0">标准版</span>
						<span v-if="scope.row.packType==1">定制版</span>
					</template>
				</el-table-column>
				<el-table-column prop="packPrice" label="价格(元)">
				</el-table-column>
				<el-table-column prop="miniNum" label="起订数量(个)">
				</el-table-column>
				<el-table-column prop="leadTime" label="备货周期(天)">
				</el-table-column>
				<el-table-column prop="signerNum" label="签收人数">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="select-txt" @click="selectConfirm(scope.row)">选择</span>
					</template>
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange" />
			<div class="submit-button">
				说明：另按采购商品总额的6%收取税点
			</div>
		</el-dialog>
		<!--报名表详情弹窗-->
		<el-dialog title="背包信息详情" :visible.sync="dialogPackDetail" width="50%" @click="dialogPackDetail=false">
			<table class="dialog-table">
				<tr>
					<th>背包名称</th>
					<td>{{packInfo.packName}}</td>
				</tr>
				<tr>
					<th>背包类型</th>
					<td>
						<span v-if="packInfo.packType==1">定制版</span>
						<span v-else>标准版</span>
					</td>
				</tr>
				<tr>
					<th>价格</th>
					<td>{{packInfo.packPrice}}</td>
				</tr>
				<tr>
					<th>起订数量</th>
					<td>{{packInfo.miniNum}}</td>
				</tr>
				<tr>
					<th>备货周期（天）</th>
					<td>{{packInfo.leadTime}}</td>
				</tr>
				<tr>
					<th>签收人数</th>
					<td>{{packInfo.signerNum}}</td>
				</tr>
				<tr>
					<th>给受助者物品</th>
					<td v-html="packInfo.itemDetails"></td>
				</tr>
				<tr>
					<th>给志愿者物品</th>
					<td v-html="packInfo.volunteerItemDetails"></td>
				</tr>
				<tr>
					<th>背包详情</th>
					<td v-html="packInfo.packDetails"></td>
				</tr>
				<tr>
					<th>状态</th>
					<td>
						<span v-if="packInfo.status==1">启用</span>
						<span v-else>禁用</span>
					</td>
				</tr>
			</table>
		</el-dialog>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		ajaxParam,
		config
	} from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	import moment from 'moment'
	import Pagination from '@/components/admin/pagination'
	import { quillEditor } from "vue-quill-editor"; //调用编辑器
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	import { Quill } from "vue-quill-editor"; 
	import { eeSourceBtn } from '@/units/quill.eeSourceBtn.js';
	// 注册我们写的事件
	Quill.register( 'modules/eeSourceBtn', eeSourceBtn );
	export default {
		name: 'AddActivity',
		components: {
			Title,
			quillEditor,
			Pagination
		},
		data() {
			return {
				stepIndex: 0,
				uploadUrl: '', //图片上传地址
				dialogVisible: false,
				dialogImageUrl: '',
				logoList: [], //logo图片回显示
				bannerList: [], //banner图片回显示
				sponsorList: [],
				sponsorListBack: [],
				regionType: 1, //1.省 2.市 3.区，县
				parentId: '',
				cityName: '',
				cityList: [],
				provinceName: '',
				provinceList: [],
				dialogSelVisible: false,
				pageSize: 10,
				pageNum: 1,
				total: 0,
				goodsList: [],
				packName: '',
				dialogPackDetail: false,
				packInfo: {},
				auditStatus: '', //审核状态
				publishStatus: 0,
				editorOption: {
					placeholder: "在此简要清晰描述活动的背景与主题、以及为志愿者提供和支持了什么、和需要其完成的任务及要求等内容",
					modules: {
						eeSourceBtn: eeSourceBtn,  // 引入我我们新增的事件
						toolbar: {
							container: [
								['bold', 'strike'],    //加粗，斜体，下划线，删除线
								[{ 'script': 'sub' }, { 'script': 'super' }],   // 上下标
							]
						}
					}
				},
				editorOption1: {
					placeholder: "请输入内容",
					modules: {
						eeSourceBtn: eeSourceBtn,  // 引入我我们新增的事件
						toolbar: {
							container: [
								['bold', 'strike'],    //加粗，斜体，下划线，删除线
								[{ 'script': 'sub' }, { 'script': 'super' }],   // 上下标
							]
						}
					}
				},
				formInfo: {
					id: '', //活动id,修改时用
					startCompanyId: '', //举办公司id
					vacationName: '', //活动名称
					activityType: '0', //活动类型(0包裹发放，1最美推荐))
					deliveryType: '1', //配送方式(0现场领取，1邮寄配送)
					//logoFileUrl: '', //活动logo地址
					bannerFileUrl: '', //海报地址
					videoFileUrl: '', //视频地址
					videoId: '', //视频id
					content: '', //活动简介
					recruitStartTime: '', //招募开始时间
					recruitEndTime: '', //招募结束时间
					recruitNums: '', //招募人数
					cardNum: '', //抢占名额
					recruitType: '0', //招募范围(0全国范围高校，1限定地区高校)
					contactPerson: '', //联系人
					contactPhone: '', //电话
					practiceHour: '', //社会实践时长
					recruitNames: '',
					provinceName: '', //省名
					recruitIds: '0',
					startLogo1FileUrl: '',
					startLogo2FileUrl: '',
					startLogo3FileUrl: '',
					startLogo1FileUrlId: '',
					startLogo2FileUrlId: '',
					startLogo3FileUrlId: ''
				},
				formInfo2: {
					id: '', //活动id
					materialSources: '1', //0平台采购, 1自备包裹
					signNum: '', //签收人数
					packPrice: '', //包裹价值
					goodsDetails: '', //签收物品明细
					volunteerItemDetails: '', //给志愿者物品
					packName: '', //包裹名称
					packId: '', //包裹id
					miniNum: '', //起订数量
					signerNum: '', //签收人数
					leadTime: '', //	备货周期
					purchaseNum: '',
					packType: ''
				},
				rulesForm2: {
					materialSources: [{
						required: true,
						message: '请选择物资来源',
						trigger: 'blur'
					}],
					signNum: [{
						required: true,
						message: '请填写每个包裹需要的签收人数',
						trigger: 'blur'
					}],
					packPrice: [{
						required: true,
						message: '请填写每个包裹的价值',
						trigger: 'blur'
					}],
					goodsDetails: [{
						required: true,
						message: '请输入给受助者物品',
						trigger: 'blur'
					}],
					// volunteerItemDetails: [{
					// 	required: true,
					// 	message: '请输入给志愿者物品',
					// 	trigger: 'blur'
					// }],
				},
				rules: {
					vacationName: [{
						required: true,
						message: '请输入活动名称',
						trigger: 'blur'
					}],
					activityType: [{
						required: true,
						message: '请选择活动类型',
						trigger: 'blur'
					}],
					deliveryType: [{
						required: true,
						message: '请选择领取方式',
						trigger: 'blur'
					}],
					// logoFileUrl: [{
					// 	required: true,
					// 	message: '请上传logo',
					// 	trigger: 'blur'
					// }],
					bannerFileUrl: [{
						required: true,
						message: '请上传海报',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入活动简介',
						trigger: 'blur'
					}],
					recruitStartTime: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					recruitEndTime: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'blur'
					}],
					recruitNums: [{
						required: true,
						message: '请输入招募人数',
						trigger: 'blur'
					}],
					cardNum: [{
						required: true,
						message: '请输入抢席位名额',
						trigger: 'blur'
					}],
					recruitType: [{
						required: true,
						message: '请选择招募范围',
						trigger: 'blur'
					}],
					contactPerson: [{
						required: true,
						message: '请输入联系人',
						trigger: 'blur'
					}],
					contactPhone: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}]
				}
			}
		},
		watch: {
			provinceName(newVal) {
				this.formInfo.provinceName = newVal
				this.provinceList.forEach(item => {
					if (newVal == item.keyName) {
						this.cityName = ''
						this.regionType = 2
						this.parentId = item.id
						this.formInfo.recruitIds = '0,' + item.id
						this.getCityList()
					}
				})
			},
			cityName(newVal) {
				this.formInfo.recruitNames = newVal
				this.cityList.forEach(item => {
					if (newVal == item.keyName) {
						this.formInfo.recruitIds += ',' + item.id
					}
				})
			}
		},
		created() {

			this.formInfo.startCompanyId = localStorage.getItem('companyId')
			this.uploadUrl = config.baseUrl + 'admin/sys/upload'
			if (this.$route.query.id) {
				//有活动id 说明是修改活动
				this.formInfo.id = this.$route.query.id
				this.formInfo2.id = this.$route.query.id
				this.getDetailData()
			}
			this.getProvinceList()
		},
		methods: {
			//获取活动详情
			async getDetailData() {
				let param = {
					id: this.formInfo.id
				}
				ajaxParam(param)
				const res = await post('admin/vacation/detail', qs.stringify(param))
				let entity = res.data.entity
				//修改时数据回显
				this.auditStatus = entity.auditStatus
				this.publishStatus = entity.publishStatus
				this.formInfo.vacationName = entity.vacationName
				this.formInfo.activityType = entity.activityType
				this.formInfo.deliveryType = entity.deliveryType
				//this.formInfo.logoFileUrl = entity.logoFileUrl
				this.formInfo.bannerFileUrl = entity.bannerFileUrl
				this.formInfo.videoFileUrl = entity.videoFileUrl || ''
				//限定地区时再回显
				if (entity.recruitType == '1') {
					this.formInfo.recruitIds = entity.recruitIds || '0'
					this.formInfo.recruitNames = entity.recruitNames || ''
					this.cityName = entity.recruitNames
					this.provinceName = entity.provinceName
					let idArr = entity.recruitIds.split(',')
					//修改的时候获取当前省的id，以后点击市的时候获取数据
					if (idArr.length > 1) {
						this.regionType = 2
						this.parentId = idArr[1]
					}
				}

				// this.logoList.push({
				// 	url: entity.logoFileUrl
				// })
				this.bannerList.push({
					url: entity.bannerFileUrl
				})
				if (entity.startLogo1FileUrlId && !entity.startLogo2FileUrlId) {
					this.sponsorListBack.push({
						url: entity.startLogo1FileUrl,
						id: entity.startLogo1FileUrlId
					})
				}
				if (entity.startLogo2FileUrlId && !entity.startLogo3FileUrlId) {
					this.sponsorListBack.push({
						url: entity.startLogo1FileUrl,
						id: entity.startLogo1FileUrlId
					})
					this.sponsorListBack.push({
						url: entity.startLogo2FileUrl,
						id: entity.startLogo2FileUrlId
					})
				}
				if (entity.startLogo3FileUrlId) {
					this.sponsorListBack.push({
						url: entity.startLogo1FileUrl,
						id: entity.startLogo1FileUrlId
					})
					this.sponsorListBack.push({
						url: entity.startLogo2FileUrl,
						id: entity.startLogo2FileUrlId
					})
					this.sponsorListBack.push({
						url: entity.startLogo3FileUrl,
						id: entity.startLogo3FileUrlId
					})
				}
				this.formInfo.content = entity.content
				this.formInfo.recruitNums = entity.recruitNums
				this.formInfo.cardNum = entity.cardNum
				this.formInfo.recruitType = entity.recruitType
				this.formInfo.contactPerson = entity.contactPerson
				this.formInfo.contactPhone = entity.contactPhone
				this.formInfo.practiceHour = entity.practiceHour||''
				this.formInfo.recruitStartTime = moment(new Date(entity.recruitStartTime * 1000)).format(
					'YYYY-MM-DD HH:mm:ss')
				this.formInfo.recruitEndTime = moment(new Date(entity.recruitEndTime * 1000)).format(
					'YYYY-MM-DD HH:mm:ss')
				//第二步数据回显
				this.formInfo2.materialSources = entity.materialSources || '1'
				this.formInfo2.signNum = entity.signNum || ''
				this.formInfo2.packPrice = entity.packPrice == undefined ? '' : entity.packPrice
				this.formInfo2.goodsDetails = entity.goodsDetails || ''
				this.formInfo2.volunteerItemDetails = entity.volunteerItemDetails || ''
				this.formInfo2.packName = entity.packName|| ''
				this.formInfo2.signerNum = entity.signerNum1 || ''
				this.formInfo2.leadTime = entity.leadTime|| ''
				this.formInfo2.miniNum = entity.miniNum|| ''
				this.formInfo2.purchaseNum = entity.purchaseNum|| ''
				this.formInfo2.packType = entity.packType|| ''
				//把回显的图片加到数组中，用同一个数组上传图片样式有点问题
				this.sponsorList.push(...this.sponsorListBack)
			},
			//第一步提交
			toConfirm() {
				this.$refs.ruleForm.validate(async valid => {
					if (valid) {
						// if(this.formInfo.coverId==''){
						// 	this.$message.error('请上传投票封面')
						// 	return
						// }
						//提交
						if (this.sponsorList.length == 1) {
							this.formInfo.startLogo1FileUrl = this.sponsorList[0].url
							this.formInfo.startLogo1FileUrlId = this.sponsorList[0].id
						}
						if (this.sponsorList.length == 2) {
							this.formInfo.startLogo1FileUrl = this.sponsorList[0].url
							this.formInfo.startLogo1FileUrlId = this.sponsorList[0].id
							this.formInfo.startLogo2FileUrl = this.sponsorList[1].url
							this.formInfo.startLogo2FileUrlId = this.sponsorList[1].id
						}
						if (this.sponsorList.length == 3) {
							this.formInfo.startLogo1FileUrl = this.sponsorList[0].url
							this.formInfo.startLogo1FileUrlId = this.sponsorList[0].id
							this.formInfo.startLogo2FileUrl = this.sponsorList[1].url
							this.formInfo.startLogo2FileUrlId = this.sponsorList[1].id
							this.formInfo.startLogo3FileUrl = this.sponsorList[2].url
							this.formInfo.startLogo3FileUrlId = this.sponsorList[2].id
						}
						this.formInfo.startCompanyId = localStorage.getItem('companyId')
						this.formInfo.startCompanyName = localStorage.getItem('companyName')
						let param = this.formInfo
						console.log(param)
						ajaxParam(param)
						const res = await post('admin/vacation/save', qs.stringify(param))
						if (res.data.code == 200) {
							if(this.formInfo.activityType == 0){
								this.stepIndex = 1
								let id = res.data.entity.id
								this.formInfo2.id = id
								this.formInfo.id = id
							}else{

								if (this.formInfo2.id) {
									this.$message.success('修改活动成功！')
								} else {
									this.$message.success('添加活动成功！')
								}
								setTimeout(res => {
									this.$router.push({
										path: '/admin/activityList'
									})
								}, 300)
							}
						
						} else {
							this.$message.error(res.data.msg)
						}
					}
				})
			},
			//第二步提匀
			toSubmit() {
				this.$refs.ruleForm2.validate(async valid => {
					if (valid) {
						if(this.formInfo2.materialSources==0) {
							if (this.formInfo2.purchaseNum > this.formInfo2.miniNum && this.formInfo2.purchaseNum >
								this.formInfo.recruitNums) {
							
							} else {
								this.$message.error('订购数量必须大于等于起订数量和招募人数中的最大值')
								return false
							}
						}
						
						let param = this.formInfo2
						console.log(param)
						ajaxParam(param)
						const res = await post('admin/vacation/editOver', qs.stringify(param))
						if (res.data.code == 200) {
							if (this.formInfo2.id) {
								this.$message.success('修改活动成功！')
							} else {
								this.$message.success('添加活动成功！')
							}
							setTimeout(res => {
								this.$router.push({
									path: '/admin/activityList'
								})
							}, 300)
						} else {
							this.$message.error(res.data.msg)
						}
					}
				})
			},
			//确认选择商品
			selectConfirm(row) {
				this.formInfo2.packId = row.id
				this.formInfo2.packName = row.packName
				this.formInfo2.packPrice = row.packPrice
				this.formInfo2.signerNum = row.signerNum
				this.formInfo2.leadTime = row.leadTime
				this.formInfo2.miniNum = row.miniNum
				if(row.packType==1){
					this.formInfo2.packType = '定制版'
				} else if(row.packType==0){
					this.formInfo2.packType = '标准版'
				}
				this.dialogSelVisible = false
				this.goodsList = []
				this.pageNum = 1
				this.packName = ''
			},
			//选择商品弹窗
			selectGoods() {
				this.dialogSelVisible = true
				this.getGoodsList()
			},
			//获取选择商品列表
			async getGoodsList() {
				let param = {
					packName: this.packName,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/vacation/packList', qs.stringify(param))
				if (res.data.code == 200) {
					let datalist = res.data.page.items
					this.goodsList = datalist
					this.total = res.data.page.count
				} else {
					this.$message.error(res.data.msg)
				}

			},
			toSearch() {
				this.pageNum = 1
				this.total = 0
				this.getGoodsList()
			},
			toReset() {
				this.packName = ''
				this.pageNum = 1
				this.goodsList = []
				this.getGoodsList()
			},
			//分页
			handleCurrentChange(e) {
				this.goodsList = []
				this.pageNum = e.number
				this.getGoodsList()
			},
			toSubmitGoods() {

			},
			//获取地区
			async getProvinceList() {
				let param = {
					regionType: this.regionType,
					parentId: this.parentId
				}
				ajaxParam(param)
				const res = await post('admin/sys/regionList', qs.stringify(param))
				if (res.data.code == 200) {
					this.provinceList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			async getCityList() {
				let param = {
					regionType: this.regionType,
					parentId: this.parentId
				}
				ajaxParam(param)
				const res = await post('admin/sys/regionList', qs.stringify(param))
				if (res.data.code == 200) {
					this.cityList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			selectProvince(e) {
				this.provinceName = e
				this.getCityList()
			},
			selectRecruitType(e) {
				this.formInfo.recruitType = e
				this.formInfo.provinceName = ''
				this.formInfo.recruitIds = ''
				this.formInfo.recruitNames = ''
				this.provinceName = ''
				this.cityName = ''
			},
			//修改的时候点击市获取市的下拉数据
			cityChange(e) {
				this.getCityList()
			},
			//上一步
			toPrev() {
				this.stepIndex = 0
			},
			//上传图片相关
			handleRemoveLogo(file) {
				console.log(file);
			},
			handleSuccessLogo(res) {
				let entity = res.entity
				this.formInfo.logoFileUrl = entity.fileUrl
			},
			handlePreviewLogo(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleSuccessBanner(res) {
				let entity = res.entity
				this.formInfo.bannerFileUrl = entity.fileUrl
			},
			handleSuccessVideo(res) {
				let entity = res.entity
				this.formInfo.videoFileUrl = entity.fileUrl
			},
			handleSuccessSponsor(res) {
				let entity = res.entity
				this.sponsorList.push({
					url: entity.fileUrl,
					id: entity.id
				})
			},
			handleRemoveSponsor(res) {
				let id = res.id
				this.sponsorList.forEach((item, index) => {
					if (item.id == id) {
						this.sponsorList.splice(index, 1)
					}
				})
			},
			handleRemoveVideo(res) {
				this.formInfo.videoFileUrl = ''
			},
			beforeUpload(file) {
				const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
				const whiteList = ['jpg', 'jpeg', 'png', 'gif']
				if (whiteList.indexOf(fileSuffix) == -1) {
					this.$message.error("只能上传jpg,jpeg,png,gif格式图片！")
					return false
				}
			},
			beforeUploadVideo(file){
				const isLt30MB = file.size / 1024 /1024 < 30;
				if (!isLt30MB) {
					this.$message.error('大小不能超过30MB!');
					return false;
				}
				return true;
			},
			handleExceedbanner(){
				this.$message.error('请先删除已存在活动海报后再上传！')
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			toPackDetail(row){
				this.dialogPackDetail = true
				this.getPackDetail(row)
			},
			//获取背包详情
			async getPackDetail(row) {
				let param = {
					id: row.id
				}
				ajaxParam(param)
				const res = await post('admin/vacation/packInfo', qs.stringify(param))
				if (res.data.code == 200) {
					this.packInfo = res.data.entity
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}

	.steps {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 30px 0;

		.steps-list {
			display: flex;
			color: #323233;

			i {
				width: 24px;
				height: 24px;
				background: #EAEBEB;
				margin-right: 10px;
				border-radius: 50%;
				text-align: center;
				line-height: 24px;
			}

			span {
				opacity: .4;
			}
		}

		.steps-current {
			color: #EB6B1B;

			i {
				background-color: #EB6B1B;
				color: #fff;
			}

			span {
				opacity: 1;
			}
		}

		.steps-line {
			width: 160px;
			height: 2px;
			background: #EB6B1B;
			margin: 0 15px;
		}
	}

	.add-form {
		width: 60%;
		margin: 0 auto;

		.confirm-btn {
			width: 78px;
			background: #EB6B1B;
			border-color: #EB6B1B;
		}

		.cancel-btn:hover {
			color: #606266;
		}
	}

	// /deep/ .el-form-item:last-of-type {
	// 	display: flex;
	// 	flex-direction: column;

	// 	.el-form-item__label {
	// 		text-align: left;
	// 	}
	// }
	.steps-btn {
		display: flex;
		justify-content: space-between;
	}

	.upload-video {
		width: 100%;
		max-height: 200px;
		margin-top: 20px
	}

	.select-area {
		margin: 10px 0 0;

		.el-select {
			margin-right: 20px;
		}
	}

	/deep/ .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .el-upload--picture-card {
		width: 120px;
		height: 120px;
		line-height: 120px;
	}

	/deep/ .sponsor .el-upload-list--picture-card .el-upload-list__item,
	/deep/ .sponsor .el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 80px;
	}

	.editor-wrap {
		// border: 1px solid #DCDFE6;
		// border-radius: 4px;
		margin-bottom: 60px;
		.editor{
			height: 200px;
		}
	}

	.submit-button {
		display: flex;
		justify-content: flex-end;
		padding-top: 20px;
	}

	/deep/ .el-dialog__body .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px !important;
	}

	.select-txt {
		color: #EB6B1B;
		cursor: pointer;
	}
	/deep/ .ql-toolbar.ql-snow{
		padding: 0 8px;
	}
	.dialog-table{
		width: 100%;
		font-size: 12px;
		th{
			width: 130px;
			background: #F3F4F6;
		}
		th,td{
			padding: 8px 20px;
			border: 1px solid #DBDCDC
		}
		td .certificate{
			width: 130px;
		}
	}
</style>